import { render } from "./CYoutube.vue?vue&type=template&id=8f208364"
import script from "./CYoutube.vue?vue&type=script&lang=js"
export * from "./CYoutube.vue?vue&type=script&lang=js"

import "./CYoutube.vue?vue&type=style&index=0&id=8f208364&lang=scss"

import exportComponent from "/Users/user/Desktop/work_projects/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__